export default __webpack_public_path__ + "2f5906103601059bd69cd8177af17bdc.png";